export const urls = {
  // VARATI_STAVKE_KORPE: 'DokNarudzbineStavke/vrati_stavke_dok_narudzbine',
  VARATI_STAVKE_KORPE:
    'DokNarudzbineStavke/vrati_stavke_dok_narudzbine_za_id_kupca',
  NARUCIVANJE_IZ_KORPE: 'DokNarudzbine/narucivanje_delova_korpa',
  UKLONI_IZ_KORPE: 'DokNarudzbine/narucivanje_delova_uklanjanje_iz_korpe',
  DODAVANJE_U_KORPU: 'DokNarudzbine/narucivanje_delova_dodavanje_u_korpu',
};
